import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelector = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0001 3C10.2653 3 10.5196 3.10536 10.7072 3.29289L13.7072 6.29289C14.0977 6.68342 14.0977 7.31658 13.7072 7.70711C13.3166 8.09763 12.6835 8.09763 12.293 7.70711L10.0001 5.41421L7.70717 7.70711C7.31664 8.09763 6.68348 8.09763 6.29295 7.70711C5.90243 7.31658 5.90243 6.68342 6.29295 6.29289L9.29295 3.29289C9.48049 3.10536 9.73485 3 10.0001 3ZM6.29295 12.2929C6.68348 11.9024 7.31664 11.9024 7.70717 12.2929L10.0001 14.5858L12.293 12.2929C12.6835 11.9024 13.3166 11.9024 13.7072 12.2929C14.0977 12.6834 14.0977 13.3166 13.7072 13.7071L10.7072 16.7071C10.3166 17.0976 9.68348 17.0976 9.29295 16.7071L6.29295 13.7071C5.90243 13.3166 5.90243 12.6834 6.29295 12.2929Z",
		fill: "currentColor"
	})
});
export { SvgSelector as ReactComponent };
